import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import MultiSelect from '../../../moreCore/UI/Multiselect/Multiselect';

import template from './TaskExecutionForm.html?raw';

// DOM-heavy widget: alias dom-construct to any so nested create()-results can be used as parents
// (dojo-typings type create() as Node, which its own parent param rejects). Behaviour unchanged.
const domConstruct: any = domConstructTyped;

class TaskExecutionForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    isExternalEmployee = false;
    isExecuter = false;

    _flatratesData: any = [];
    _materialData: any = [];
    _assistantData: any = [];
    _assistantWorkamounts: any = [];

    /* Workamount -WA
     * Workdate -WD
     * Assistants -AS
     * Flatrates -FR
     * Material -MA
     * Auftragsfreigabe -TA
     * */
    modes = "-WA-WD-AS-FR-MA";

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
        this._flatratesData = [];
        this._materialData = [];
        this._assistantData = [];
        this._assistantWorkamounts = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    isUseAssistants(): any {
        return this.modes.indexOf("-AS") != -1;
    }

    isUseFlatrates(): any {
        return this.modes.indexOf("-FR") != -1;
    }

    isUseMaterial(): any {
        return this.modes.indexOf("-MA") != -1;
    }

    isUseWorkamount(): any {
        return this.modes.indexOf("-WA") != -1;
    }

    isTaskApprovalMode(): any {
        return this.modes.indexOf("-TA") != -1;
    }

    isUseWorkdate(): any {
        return this.modes.indexOf("-WD") != -1;
    }

    setModes(modesString: any): void {
        if (!modesString) return;

        this.modes = modesString;

        domClass.toggle(this.workamountContainer, "w3-show", this.isUseWorkamount());
        domClass.toggle(this.workdateContainer, "w3-show", this.isUseWorkdate());
        domClass.toggle(this.flatratesContainer, "w3-show", this.isUseFlatrates() && !this.isExternalEmployee);
        domClass.toggle(this.sectionMaterial, "w3-show", this.isUseMaterial() && !this.isExternalEmployee);
        domClass.toggle(this.assistantContainer, "w3-show", this.isUseAssistants() && !this.isExternalEmployee);

        this.hideNode(this.sectionAccounting, !this.isUseAssistants() && !this.isUseWorkamount() && !this.isUseWorkdate())

    }

    setup(taskEntity: any, isExternalEmployee: any, modes: any, taskExecutionEntity: any): void {

        this.isExternalEmployee = isExternalEmployee === true;
        if (!modes) modes = this.modes;

        this.setModes(modes);

        if (this.isExternalEmployee != true) {
            domClass.remove(this.accountingContainer, "w3-hide");
            if (this.isUseAssistants()) {
                this.inputAssistantEmployee._loadListValues();
            }
        } else {
            domClass.add(this.accountingContainer, "w3-hide");
        }

        let now = new Date();
        let now_dd_mm_yyyy = dojoDateLocale.format(now, { datePattern: "yyyy-MM-dd", selector: "date" });

        this.inputWorkingAmount.value = 0.25;
        this.inputWorkingDate.value = now_dd_mm_yyyy;

        domConstruct.empty(this.selectedAssistantContainer);

        if (this._flatratesSelect != null) {
            //this._flatratesSelect.destroy();
            domConstruct.empty(this.taskFlatratesContainer);
            this._flatratesSelect = null;

            domConstruct.empty(this.taskFlatratesTableContainer);
        }

        if (this._itemSelect) {
            domConstruct.empty(this.itemClassContainer);
            domConstruct.empty(this.itemContainer);
            domConstruct.empty(this.materialTableContainer);
            this._itemSelect = null;
        }

        // multiselect für die pauschalen
        if (this.isUseFlatrates()) {
            this._flatratesSelect = new MultiSelect();
            domConstruct.place(this._flatratesSelect.domNode, this.taskFlatratesContainer);//inputDiv);
            this._flatratesSelect.set("labelAttribute", 'bezeichnung');
            this._flatratesSelect.set("valueAttribute", 'ID');

            on(this._flatratesSelect, "change", lang.hitch(this, this._onChangeSelectedFlatrates));
        }


        if (this.isExternalEmployee != true) {
            this._loadFlatrates(taskEntity);
            this._loadItemlist(taskEntity, taskExecutionEntity);
            //    domClass.remove(this.assistantContainer, "w3-hide");
            //    domClass.remove(this.sectionMaterial, "w3-hide");
        } else {
            //    domClass.add(this.assistantContainer, "w3-hide");
            //    domClass.add(this.sectionMaterial, "w3-hide");
        }

        this._assistantData = [];
    }

    getWorkingAmount(): any {
        return parseFloat(this.inputWorkingAmount.value);
    }

    getWorkingDate(): any {
        return this.inputWorkingDate.value;
    }

    _onChange_WorkingDate(evt: any): void {
        let valid = !!this.inputWorkingDate.value;


        try {
            this.hideNode(this.workingDateInvalid);

            let inputDate = new Date(this.getWorkingDate());
            let currentDate = new Date();

            if (inputDate.valueOf() > currentDate.valueOf()) {
                valid = false;
                this.hideNode(this.workingDateInvalid, false);

            }
        } catch (ex) {

        }

        domClass.toggle(this.inputWorkingDate, "w3-pale-red w3-border-red", !valid);
        domClass.toggle(this.inputWorkingDate, "mediumBrightTransparentBG w3-border-gray", valid);

    }

    _currentItemClassID: any = null;
    _rawItemsData: any = null;
    _itemclassButtons: any = [];

    _onClick_ItemClass(classID: any, button?: any, evt?: any): void {

        //evt.stopPropagation();

        for (let i = 0; i < this._itemclassButtons.length; i++) {
            domClass.remove(this._itemclassButtons[i], "selected w3-opacity");
            //domClass.add(this._itemclassButtons[i], "w3-opacity");
        }

        // hat gewechselt: itemselect erstellen und füllen

        // bestehendes entfernen:
        if (this._itemSelect != null) {
            this._itemSelect.toggleEditmode(false);
            setTimeout(lang.hitch(this, domConstruct.destroy, this._itemSelect.domNode), 300);
            domClass.add(this._itemSelect.domNode, "w3-hide");

            this._itemSelect = null;
        }

        if (this._currentItemClassID == classID) {
            classID = "all";
        }

        this._currentItemClassID = classID;

        if (this._currentItemClassID != "all") {
            domClass.add(button, "selected");

            for (let i = 0; i < this._itemclassButtons.length; i++) {
                domClass.add(this._itemclassButtons[i], "w3-opacity");
            }

            domClass.remove(button, "w3-opacity");
        }


        // multiselect für Material erstellen
        this._itemSelect = new MultiSelect();
        domConstruct.place(this._itemSelect.domNode, this.itemContainer);//inputDiv);
        this._itemSelect.set("labelAttribute", 'Name');
        this._itemSelect.set("valueAttribute", 'ID');

        this._buildItemSelection(this._currentItemClassID);

        if (evt) {
            evt.stopPropagation();
        }

        if (this._currentItemClassID != "all") {
            this._itemSelect.toggleEditmode(true);
        }

        on(this._itemSelect, "change", lang.hitch(this, this._onChangeSelectedMaterial));

        //domClass.remove(this.itemContainer, "w3-hide");

    }

    _loadItemlist(taskEntity: any, taskExecutionEntity: any): void {
        if (this.isUseMaterial() != true) return;
        //
        this.StandbyStart(this.itemClassContainer);
        var fct = "Webtool_Occurrence_API_GetItemList";

        var data: any = { taskID: taskEntity.ID };
        this._materialData = [];

        if (taskExecutionEntity) {
            data.taskExecutionID = taskExecutionEntity.ID;
        }

        if (this.isTaskApprovalMode()) {
            data.taskApprovalMode = true;
            fct = "Webtool_API_TaskApproval__LoadMaterial";
        }

        this.RequestManager.callfunction(
            fct,
            data,
            lang.hitch(this, this._loadItemsResponse),
            lang.hitch(this, this._loadItemsError, taskEntity)
        );
    }

    _loadItemsResponse(response: any): void {

        this.StandbyStop();

        // Buttons für die Materialklassen bauen:
        domConstruct.empty(this.itemClassContainer);

        this._rawItemsData = response.itemclasses;
        this._units = response.units;
        this._itemclassButtons = [];

        if (this._rawItemsData.length == 0) {
            //    // leer?
            //    return;
        }

        this.buildMaterialRegistry(this._rawItemsData, response.selection);

        for (let i = 0; i < this._rawItemsData.length; i++) {
            let itemclass = this._rawItemsData[i];

            let button = domConstruct.create("button", {
                "className": "mds-button-base w3-margin-right w3-padding mds-hover-dark itemclass",
                innerHTML: itemclass.Name
            }, this.itemClassContainer);

            if (itemclass.Coloration) {
                if (!itemclass.Coloration.TextColor.IsNull) {
                    domStyle.set(button, "color", itemclass.Coloration.TextColor.Hex);
                }

                if (!itemclass.Coloration.BackColor.IsNull) {
                    domStyle.set(button, "backgroundColor", itemclass.Coloration.BackColor.Hex);
                }
            }

            on(button, "click", lang.hitch(this, this._onClick_ItemClass, itemclass.ID, button));

            this._itemclassButtons.push(button);

            this._currentItemClassID = "all";
            this._onClick_ItemClass("all");
        }

    }

    _loadItemsError(taskEntity: any, error: any): void {
        this.StandbyStop();

        on(this.itemClassContainer.firstChild, "click", lang.hitch(this, this._loadItemlist, taskEntity));
        domClass.add(this.itemClassContainer.firstChild, "mds-button-base w3-padding mds-hover-dark");
        domClass.remove(this.itemClassContainer.firstChild, "w3-disabled");
        this.itemClassContainer.firstChild.innerHTML = this.translations["General_Reload"];

        this.errorMessage.innerHTML = error.Message;
    }

    _buildItemSelection(classID: any): void {
        let currentSelection = [];
        let items = [];

        for (let i = 0; i < this._rawItemsData.length; i++) {
            let itemclass = this._rawItemsData[i];

            for (let item of itemclass.items) {
                item.selectable = true;
            }

            if (itemclass.ID == classID || classID == "all") {

                // gefunden - aus der selectierten Data rausfiltern was schon selektiert ist ... omfg
                for (let x = 0; x < this._materialData.length; x++) {
                    let material = this._materialData[x];

                    if (material.classID == classID || classID == "all") {
                        if (material.isSelected === true) {
                            currentSelection.push(material.itemID);
                        }

                        for (let item of itemclass.items) {
                            if (item.ID == material.itemID) {
                                item.selectable = material.canEdit !== false;
                                break;
                            }
                        }
                    }
                }

                items = items.concat(itemclass.items);
                //console.debug("_buildItemSelection", classID, itemclass, this._materialData, currentSelection)
                this._itemSelect.selectableAttribute = "selectable";

                this._itemSelect.setData(currentSelection, items);
                //setData(presetValue: any, data: any, bSuppressChange ?: boolean): void {

                //this._itemSelect.buildListValues(items, currentSelection);// immer frisch starten!, response.rawSelectedValues);
                //setOptions(values: Array < string >, labels: Array < string >, preselected ?: Array < any >, selectable ?: Array < boolean >) {

            }
        }

    }

    _onChangeSelectedMaterial(values: any): void {
        //console.debug("_onChangeSelectedMaterial", values, this._currentItemClassID, this._materialData);
        this.updateMaterialRegistry();

        this.buildMaterialTable();
    }

    updateMaterialRegistry(targetID?: any): void {
        let targetAmount = "1";
        let note = "";
        let unit = "";
        let label = "";
        let price = "0";
        if (typeof (targetID) != "undefined") {
            let input: any = document.getElementById(targetID);
            targetAmount = input.value;

            let noteInput: any = document.getElementById("note-" + targetID);
            note = noteInput.value;

            // nur bei custom material:
            let unitInput: any = document.getElementById("unit-" + targetID);
            if (unitInput) unit = unitInput.value;

            let labelInput: any = document.getElementById("label-" + targetID);
            if (labelInput) label = labelInput.value;

            let priceInput: any = document.getElementById("price-" + targetID);
            if (priceInput) price = priceInput.value;

        } else {

        }

        let selectedIDs: any = [];
        if (this._itemSelect) {
            selectedIDs = this._itemSelect.get("value");
        }

        //console.debug("updateMaterialRegistry", selectedIDs, this._materialData);

        for (var i = 0; i < this._materialData.length; i++) {
            let pseudoEntry = this._materialData[i];

            if (pseudoEntry.itemID == targetID && pseudoEntry.classID == "custom") {
                pseudoEntry.quantity = parseFloat(targetAmount);
                pseudoEntry.unitprice = parseFloat(price);
                pseudoEntry.note = note;
                pseudoEntry.label = label;
                pseudoEntry.unit = unit;
            }

            else if (pseudoEntry.classID != "custom") {
                if (pseudoEntry.classID == this._currentItemClassID
                    || this._currentItemClassID == "all") {

                    if (selectedIDs.indexOf(pseudoEntry.itemID) != -1) {
                        pseudoEntry.isSelected = true;

                        if (targetID == pseudoEntry.itemID || pseudoEntry.quantity == null) {
                            pseudoEntry.quantity = parseFloat(targetAmount);
                        }

                        if (targetID == pseudoEntry.itemID) {
                            pseudoEntry.note = note;
                        }

                    } else {
                        pseudoEntry.isSelected = false;
                    }
                }
            }
        }

    }

    buildMaterialTable(): void {
        domConstruct.empty(this.materialTableContainer);
        domClass.add(this.materialTableContainer, "w3-hide");
        var table = domConstruct.create("table", { "className": "materialTable" }, this.materialTableContainer);

        console.debug("buildMaterialTable", this._materialData);

        //var headrow = domConstruct.create("tr", {}, table);

        //var headLabel = domConstruct.create("th", { "innerHTML": "" }, headrow);
        //var headLabel = domConstruct.create("th", { "innerHTML": "#" }, headrow);

        for (var i = 0; i < this._materialData.length; i++) {
            let pseudoEntry = this._materialData[i];

            if (pseudoEntry.isSelected === true) {
                let row = domConstruct.create("tr", {}, table);

                // Klasse ermitteln für mehr Details...
                let itemclass = null;
                for (let x = 0; x < this._rawItemsData.length; x++) {
                    if (this._rawItemsData[x].ID == pseudoEntry.classID) {
                        itemclass = this._rawItemsData[x];
                        break;
                    }
                }

                let colLabel = domConstruct.create("td", { "innerHTML": pseudoEntry.label }, row);
                let colClass = domConstruct.create("td", { "innerHTML": "", "className": "w3-padding w3-center" }, row);
                let spanClass = domConstruct.create("span", { "innerHTML": "", "className": "w3-small w3-center w3-padding-small w3-border round " }, colClass);
                let colAmount = domConstruct.create("td", {}, row);
                let colUnit = domConstruct.create("td", { innerHTML: "", style: { "whiteSpace": "nowrap" } }, row);
                let colPrice = domConstruct.create("td", { innerHTML: "", style: { "textAlign": "center" } }, row);
                let colNoteinput = domConstruct.create("td", { innerHTML: "", "colSpan": "2" }, row);
                let inputNote = domConstruct.create("textarea", {
                    "value": pseudoEntry.note,
                    "className": "w3-input w3-border",
                    style: {
                        /*"width": "35ch",*/
                        "resize": "vertical"
                    },
                    "placeholder": this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]
                }, colNoteinput);
                inputNote.id = "note-" + pseudoEntry.itemID;

                let colRemove = domConstruct.create("td", {}, row);
                let inputAmount = domConstruct.create("input", {
                    "value": pseudoEntry.quantity.toString(),
                    "type": "number",
                    "step": "0.1",
                    "className": "w3-border round mediumBrightTransparentBG w3-input w3-padding-small w3-border-gray"
                }, colAmount);
                inputAmount.id = pseudoEntry.itemID;

                if (pseudoEntry.isCatalog != true) {

                    domClass.add(row, "customItem");

                    domConstruct.empty(colLabel);
                    domAttr.set(colLabel, "colspan", "2");
                    domAttr.set(colNoteinput, "colspan", "1");
                    domConstruct.empty(colUnit);
                    domConstruct.destroy(colClass);

                    let inputLabel = domConstruct.create("input",
                        {
                            "value": pseudoEntry.label,
                            "className": "w3-input w3-border",
                            style: { "minWidth": "20ch", "width": "100%" },
                            "placeholder": this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_CustomMaterialLabel"]
                        }, colLabel);
                    inputLabel.id = "label-" + pseudoEntry.itemID;

                    let unitLabel = domConstruct.create("label", {
                        "for": "unit-" + pseudoEntry.itemID,
                        "innerHTML": this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_CustomMaterialUnitLabel"],//"Gesamtpreis",
                        "className": "w3-small"
                    }, colUnit)

                    let inputUnit = domConstruct.create("select",
                        {
                            "value": pseudoEntry.unit,
                            "className": "w3-input w3-border"
                        }, colUnit);
                    inputUnit.id = "unit-" + pseudoEntry.itemID;

                    for (let x = 0; x < this._units.length; x++) {
                        let unit = this._units[x];

                        let option = domConstruct.create("option", { "value": unit.ID, innerHTML: unit.Name }, inputUnit);
                        if (unit.ID == pseudoEntry.unit) {
                            option.selected = true;
                        }
                    }


                    let priceContainer = domConstruct.create("div", {
                        "className": "centerContainer"
                    }, colPrice);

                    let priceLabel = domConstruct.create("label", {
                        "for": "price-" + pseudoEntry.itemID,
                        "innerHTML": this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_CustomMaterialPriceLabel"],//"Gesamtpreis",
                        "className": "w3-small"
                    }, priceContainer)
                    let inputPrice = domConstruct.create("input", {
                        "value": pseudoEntry.unitprice ? pseudoEntry.unitprice.toString() : "0.00",
                        "type": "number",
                        "step": "0.01",
                        "className": "w3-border round mediumBrightTransparentBG w3-input w3-padding-small w3-border-gray",
                        style: {
                            "width": "85px"
                        }
                    }, priceContainer);
                    inputPrice.id = "price-" + pseudoEntry.itemID;

                    if (pseudoEntry.canEdit !== false) {
                        on(inputLabel, "change", lang.hitch(this, this.updateMaterialRegistry, pseudoEntry.itemID));
                        on(inputUnit, "change", lang.hitch(this, this.updateMaterialRegistry, pseudoEntry.itemID));
                        on(inputPrice, "change", lang.hitch(this, this.updateMaterialRegistry, pseudoEntry.itemID));

                    } else {
                        domClass.add(row, "noInteraction w3-opacity");
                    }


                } else {
                    domConstruct.destroy(colPrice);
                    let unitLabel = "€{0} / {1}".format(pseudoEntry.unitprice.toFixed(2), pseudoEntry.unit);
                    colUnit.innerHTML = unitLabel;
                }

                if (itemclass != null) {
                    spanClass.innerHTML = itemclass.Name;

                    if (itemclass.Coloration) {
                        if (itemclass.Coloration.TextColor.IsNull !== true) {
                            domStyle.set(spanClass, "borderColor", itemclass.Coloration.TextColor.Hex);
                            domStyle.set(spanClass, "color", itemclass.Coloration.TextColor.Hex);
                        }

                        if (itemclass.Coloration.BackColor.IsNull !== true) {
                            domStyle.set(spanClass, "backgroundColor", itemclass.Coloration.BackColor.Hex);
                        }
                    }
                }
                if (pseudoEntry.canEdit !== false) {
                    let button = domConstruct.create("button", { "className": "mds-button-base round mds-hover-dark w3-pale-red w3-red", innerHTML: "<i class='fas fa-times'></i>" }, colRemove);
                    on(button, "click", lang.hitch(this, this._deselectMaterial, pseudoEntry));

                    on(inputAmount, "change", lang.hitch(this, this.updateMaterialRegistry, pseudoEntry.itemID));
                    on(inputNote, "change", lang.hitch(this, this.updateMaterialRegistry, pseudoEntry.itemID));
                } else {
                    domClass.add(row, "noInteraction w3-opacity");
                }
                domClass.remove(this.materialTableContainer, "w3-hide");
            }

        }
    }

    buildMaterialRegistry(classlist: any, selectedValues: any): void {
        // Pseudo-HT-Einträge machen
        if (typeof (classlist != "undefined")) {
            this._materialData = [];
            for (var i = 0; i < classlist.length; i++) {

                let itemclass = classlist[i];

                for (let x = 0; x < itemclass.items.length; x++) {

                    let entry = itemclass.items[x];

                    let pseudoEntry: any = {
                        isSelected: false, // kommt aus dem Multiselect!
                        itemID: entry.ID,
                        classID: itemclass.ID,
                        label: entry.Name,
                        unit: entry.ref_quantity_unit ? entry.ref_quantity_unit.Name : "",
                        unitprice: entry.Unit_price,
                        note: "",
                        isCatalog: true, // User kann eigene Einträge und Bezeichnungen hinzufügen
                        quantity: null, // noch nichts gewählt
                        selectionID: null // keine ID, weils noch kein ht-entry gibt
                    };

                    this._materialData.push(pseudoEntry);
                }
            }
        }

        // jetzt aus den bereits gewählten Werten die Registry updaten
        if (typeof (selectedValues) != "undefined") {
            for (let i = 0; i < selectedValues.length; i++) {
                //
                let selected = selectedValues[i];

                if (selected.isCatalog) {
                    for (let x = 0; x < this._materialData.length; x++) {
                        let pseudoEntry = this._materialData[x];

                        if (pseudoEntry.itemID == selected.itemID) {
                            pseudoEntry.isSelected = true;
                            pseudoEntry.note = selected.note;
                            pseudoEntry.quantity = selected.quantity;
                            pseudoEntry.selectionID = selected.ID;
                            pseudoEntry.canEdit = selected.canEdit !== false;
                            break;
                        }
                    }
                } else {
                    let pseudoEntry: any = {
                        ...selected
                    };
                    let token = Math.random() * 10000000000 + Math.random() * 100000000 + Math.random() * 100000;

                    pseudoEntry.classID = "custom";
                    pseudoEntry.itemID = "custom-" + token;
                    pseudoEntry.label = pseudoEntry.Name;

                    this._materialData.push(pseudoEntry);
                }
            }

            this.buildMaterialTable();
        }
    }

    _deselectMaterial(entry: any): void {
        entry.isSelected = false;
        this.buildMaterialTable();

        // falls gerade diese Klasse gewählt ist: das Multiselect neu aufbauen
        if (this._currentItemClassID == entry.classID || this._currentItemClassID == "all") {
            this._buildItemSelection(this._currentItemClassID);
        }
    }

    _onClick_AddCustomMaterial(evt: any): void {
        let token = Math.random() * 10000000000 + Math.random() * 100000000 + Math.random() * 100000;

        let pseudoEntry: any = {
            isSelected: true, // kommt aus dem Multiselect!
            itemID: "custom-" + token,
            classID: "custom",
            label: "",
            unit: "",
            unitprice: null,
            note: "",
            isCatalog: false, // User kann eigene Einträge und Bezeichnungen hinzufügen
            quantity: 1,
            selectionID: null //
        };

        this._materialData.push(pseudoEntry);

        this.buildMaterialTable();
    }

    _onChangeSelectedFlatrates(values: any): void {
        //console.debug("_onChange_SelectedFlatrates", values);

        this.updateFlatrateRegistry();

        this.buildFlatrateTable();
    }

    _loadFlatrates(taskEntity: any): void {
        if (this.isUseFlatrates() != true) return;

        this._flatratesSelect.StandbyStart();
        var url = window.appRoot + "Occurrence/GetFlatrateList";

        var data = { taskID: taskEntity.ID };
        this._flatratesData = [];

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API_GetFlatrateList",
            data,
            lang.hitch(this, this._loadFlatratesResponse),
            lang.hitch(this, this._loadFlatratesError)
        );
    }

    _loadFlatratesResponse(response: any): void {

        this.buildFlatrateRegistry(response.flatrates, response.selectedValues);
        //this.buildFlatrateTable(response.flatrates, response.selectedValues);
        domConstruct.empty(this.errorMessage);

        this._flatratesSelect.StandbyStop();
        this._flatratesSelect.setData(response.rawSelectedValues, response.flatrates);
        //this._flatratesSelect.buildListValues(response.flatrates, response.rawSelectedValues);
    }

    _loadFlatratesError(error: any): void {
        this._flatratesSelect.StandbyStop();

        this.errorMessage.innerHTML = error.Message;
    }

    buildFlatrateRegistry(originalList: any, selectedValues: any): void {
        // Pseudo-HT-Einträge machen
        if (typeof (originalList != "undefined")) {
            this._flatratesData = [];
            for (var i = 0; i < originalList.length; i++) {



                var entry = originalList[i];

                var pseudoEntry: any = {
                    isSelected: entry.is_preselected === true, // kommt aus dem Multiselect!
                    flatrateID: entry.ID,
                    label: entry.bezeichnung,
                    quantity: entry.is_preselected === true ? 1 : null, // noch nichts gewählt
                    selectionID: null // keine ID, weils noch kein ht-entry gibt
                };

                let selectedValue = null;
                if (selectedValues && entry.is_preselected === true) {
                    for (let x = 0; x < selectedValues.length; x++) {
                        selectedValue = selectedValues[x];
                        if (selectedValue.flatrateID === pseudoEntry.flatrateID) {
                            if (selectedValue.quantity) {
                                pseudoEntry.quantity = selectedValue.quantity;
                                break;
                            }
                        }

                    }
                }

                this._flatratesData.push(pseudoEntry);
            }
        }

        // jetzt aus den bereits gewählten Werten die Registry updaten
        if (typeof (selectedValues) != "undefined") {
            for (var i = 0; i < selectedValues.length; i++) {
                //
                var selected = selectedValues[i];

                for (var x = 0; x < this._flatratesData.length; x++) {
                    var pseudoEntry = this._flatratesData[x];

                    if (pseudoEntry.flatrateID == selected.flatrateID) {
                        //pseudoEntry.isSelected = true; // später -> wenn Multiselect befüllt ist setzen wir das Flag und zeichnen die Tabelle
                        pseudoEntry.quantity = selected.quantity;
                        pseudoEntry.selectionID = selected.ID;
                        break;
                    }
                }
            }
        }


    }

    updateFlatrateRegistry(targetID?: any): void {
        var targetAmount = "1";
        if (typeof (targetID) != "undefined") {
            var input: any = document.getElementById(targetID);
            targetAmount = input.value;
        } else {

        }

        if (this._flatratesData) {
            var selectedIDs = this._flatratesSelect.get("value");

            for (var i = 0; i < this._flatratesData.length; i++) {
                var pseudoEntry = this._flatratesData[i];
                if (selectedIDs.indexOf(pseudoEntry.flatrateID) != -1) {
                    pseudoEntry.isSelected = true;

                    if (targetID == pseudoEntry.flatrateID || pseudoEntry.quantity == null) {
                        pseudoEntry.quantity = parseFloat(targetAmount);
                    }
                } else {
                    pseudoEntry.isSelected = false;
                }
            }
        }

        //console.debug("updated flatrate registry", this._flatratesData, selectedIDs, targetID, targetAmount);
    }

    buildFlatrateTable(): void {
        domConstruct.empty(this.taskFlatratesTableContainer);
        domClass.add(this.taskFlatratesTableContainer, "w3-hide");
        var table = domConstruct.create("table", { "className": "flatrateTable" }, this.taskFlatratesTableContainer);

        //var headrow = domConstruct.create("tr", {}, table);

        //var headLabel = domConstruct.create("th", { "innerHTML": "" }, headrow);
        //var headLabel = domConstruct.create("th", { "innerHTML": "#" }, headrow);

        if (this._flatratesData) {
            for (var i = 0; i < this._flatratesData.length; i++) {
                var pseudoEntry = this._flatratesData[i];

                if (pseudoEntry.isSelected === true) {
                    var row = domConstruct.create("tr", {}, table);

                    var colLabel = domConstruct.create("td", { "innerHTML": pseudoEntry.label }, row);
                    var colAmount = domConstruct.create("td", {}, row);
                    var inputAmount = domConstruct.create("input", { "value": pseudoEntry.quantity, "type": "number", "step": "1", "className": "w3-border round mediumBrightTransparentBG w3-input w3-margin-left w3-padding-small w3-border-gray" }, colAmount);
                    inputAmount.id = pseudoEntry.flatrateID;

                    on(inputAmount, "change", lang.hitch(this, this.updateFlatrateRegistry, pseudoEntry.flatrateID))
                    domClass.remove(this.taskFlatratesTableContainer, "w3-hide");
                }

            }
        }
    }



    _onSelect_InputAssistant(inputData: any): void {
        console.debug("_onSelect_InputAssistant", inputData);
        //this.inputAssistantEmployee.set("value", null, true);
        //for (let i = 0; i < this._assistantData.length; i++) {
        //    if (this._assistantData[i].ID == inputData.ID) {
        //        return;
        //    }
        //}
        this._assistantData = inputData;

        let selectedAssistants = this.inputAssistantEmployee._getValueAttr(true);


        let IDs = [];
        let existingAssWaIDs = [];
        for (let x = 0; x < this._assistantWorkamounts.length; x++) {
            let entry = this._assistantWorkamounts[x];
            existingAssWaIDs.push(entry.ID);
        }

        for (let i = 0; i < selectedAssistants.length; i++) {
            let assistant = selectedAssistants[i];
            IDs.push(assistant.ID);
            let alreadyVorhanden = existingAssWaIDs.indexOf(assistant.ID) != -1;


            if (alreadyVorhanden != true) {

                let entry: any = {
                    node: null,
                    ID: assistant.ID,
                    workamount: 0
                }

                let row = domConstruct.create("tr", {
                    className: "assistandWorkamountRow mandatoryMissing"
                }, this.selectedAssistantContainer);
                entry.node = row;

                let labelTd = domConstruct.create("td",
                    {
                        "innerHTML": assistant.dispname,
                        className: ""
                    }, row);

                let inputTd = domConstruct.create("td", {}, row)

                let labelInput = domConstruct.create("label", {
                    "className": "w3-small",
                    "innerHTML": this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_WorkingAmount"]
                }, inputTd);

                let input = domConstruct.create("input", {
                    "type": "number",
                    "step": "0.25",
                    "min": "0",
                    "value": 0,
                    className: "w3-border round mediumBrightTransparentBG w3-input w3-margin-left w3-padding-small w3-border-gray"
                }, inputTd);


                on(input, "change", lang.hitch(this, function (entry, input) {
                    entry.workamount = parseFloat(input.value);
                    domClass.toggle(entry.node, "mandatoryMissing", entry.workamount == 0);
                }, entry, input));


                this._assistantWorkamounts.push(entry);
            }
        }

        for (let x = 0; x < this._assistantWorkamounts.length; x++) {
            let entry = this._assistantWorkamounts[x];

            if (IDs.indexOf(entry.ID) == -1) {
                domConstruct.destroy(entry.node);
                this._assistantWorkamounts.splice(x, 1);
                x--;
            }
        }

        domClass.toggle(this.selectedAssistantContainer, "w3-hide", this._assistantWorkamounts.length == 0);
    }

    getAssistantWorkamounts(): any {
        let workamountEntries = [];
        for (let entry of this._assistantWorkamounts) {
            workamountEntries.push({
                ID: entry.ID,
                workamount: entry.workamount
            });
        }

        return workamountEntries;
    }

    _onClick_RemoveAssistant(ID: any, evt: any): void {
        evt.stopPropagation();

        for (let i = 0; i < this._assistantData.length; i++) {
            if (this._assistantData[i].ID == (window as any).inputData.ID) { // JS2TS: 'inputData' undefined in original (latent bug) — preserved as global read to compile
                let data = this._assistantData[i];
                domConstruct.destroy(data.node);

                this._assistantData.splice(i, 1);
                return;
            }
        }

    }



}
TaskExecutionForm.prototype.declaredClass = 'WidgetCollection.JDM.TaskExecution.TaskExecutionForm';

export default mdsWidget(TaskExecutionForm);
